import React from 'react';
import MainPage from '../src/shell';
import { createRoot } from 'react-dom/client';
import { reactPlugin } from './AppInsights';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { BrowserRouter as Router } from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Router>
        <AppInsightsErrorBoundary
            onError={() => (
                <h1>Some error occurred while Loading the Application</h1>
            )}
            appInsights={reactPlugin}
        >
            <MainPage />
        </AppInsightsErrorBoundary>
    </Router>
);
